import api from "./axios";

export const getField = (id) => api.get(`/fields/${id}`);
export const updateField = (id, payload) => api.put(`/fields/${id}`, payload);
export const deleteField = (id) => api.delete(`/fields/${id}`);
